import React from "react";
import { motion } from "framer-motion";

const BOTTLE_SRC = "/assets/briology_bottle.png";

const PerfumeBottle = ({ selectedScents = [], blendName }) => {
  const n = selectedScents.length || 0;
  // Each click = 1/5 of the bottle. Empty by default.
  const fillPct = Math.min(100, (n / 5) * 100);
  const emptyTop = 100 - fillPct;

  return (
    <div
      data-testid="perfume-bottle"
      className="relative w-full max-w-[280px] mx-auto select-none"
    >
      {/* Soft holographic backdrop */}
      <div className="absolute inset-0 -m-6 holo-gradient rounded-[40px] blur-2xl opacity-50 pointer-events-none" />

      <div className="relative">
        {/* Empty / desaturated base — the bottle looks clear/empty (white-ish, not grey) when no scents are chosen */}
        <img
          src={BOTTLE_SRC}
          alt="Briology bottle"
          draggable={false}
          className="w-full h-auto block relative z-0"
          style={{
            filter:
              "saturate(0) brightness(1.65) contrast(0.78)",
          }}
        />

        {/* Yellow-liquid reveal: same photo, but clipped from the bottom upward.
            As scents are clicked, more of the saturated photo is revealed.
            A 'slosh' wobble retriggers on each scent change. */}
        <motion.div
          key={n}
          initial={{ skewX: n > 0 ? -3 : 0, scaleY: 1.04 }}
          animate={{
            skewX: [n > 0 ? -3 : 0, 2.4, -1.6, 0.9, 0],
            scaleY: [1.04, 0.97, 1.02, 0.99, 1],
          }}
          transition={{ duration: 1.05, ease: [0.22, 0.61, 0.36, 1], times: [0, 0.25, 0.55, 0.8, 1] }}
          className="absolute inset-0 z-10 pointer-events-none origin-bottom"
        >
          <motion.img
            src={BOTTLE_SRC}
            alt=""
            aria-hidden
            draggable={false}
            initial={false}
            animate={{
              clipPath: `inset(${emptyTop}% 0% 0% 0%)`,
              WebkitClipPath: `inset(${emptyTop}% 0% 0% 0%)`,
            }}
            transition={{ duration: 0.9, ease: [0.22, 0.61, 0.36, 1] }}
            className="w-full h-auto block"
            data-testid="bottle-fill-overlay"
          />
        </motion.div>

        {/* Subtle shimmer when full */}
        {n === 5 && (
          <div className="absolute inset-0 z-20 pointer-events-none shimmer opacity-30 mix-blend-overlay" />
        )}
      </div>

      {/* Blend name + counter */}
      <div className="mt-4 text-center" data-testid="bottle-meta">
        <div className="font-serif-display text-xl font-black leading-tight">
          {blendName?.trim() || "Untitled No. 1"}
        </div>
        <div className="overline text-[9px] text-black/60 mt-1">
          Briology · {n} / 5 notes
        </div>
      </div>
    </div>
  );
};

export default PerfumeBottle;
